import SvgTwitter from '../svgs/Twitter';
import SvgMail from '../svgs/Mail';
import SvgGithub from '../svgs/Github';
import SvgInstagram from '../svgs/Instagram';
import SvgFileText from '../svgs/FileText';
import SvgLinkedin from '../svgs/Linkedin';
import SvgYoutube from '../svgs/Youtube';
import { SVGProps } from 'react';

export interface SocialData {
  platform: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  link: string;
  path: string | undefined;
}

export const socialData: SocialData[] = [
  {
    platform: 'GitHub',
    icon: SvgGithub,
    link: 'https://github.com//munch-lax',
    path: '/github',
  },
  {
    platform: 'Resume',
    icon: SvgFileText,
    link: 'https://docs.google.com/document/d/1MUjfnPo9hCq5KTI8MKwrt5KhHazfkFc1Ei_EUOFWzjs/edit?usp=sharing',
    path: undefined,
  },
  {
    platform: 'LinkedIn',
    icon: SvgLinkedin,
    link: 'https://linkedin.com/in/rahul-gurnani-68234b1b7/',
    path: undefined,
  },
];
